const BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || 'https://api.givingamp.com';

export default {
  BASE_URL,
  meEndpoint: BASE_URL + '/api/auth_me/',
  loginEndpoint: BASE_URL + '/api/login/',
  forgetPasswordEndpoint: BASE_URL + '/api/password_reset/',
  resetPasswordEndpoint: BASE_URL + '/api/password_reset_confirm/',
  getEmailEndpoint: BASE_URL + '/api/get_email_from_uid/',
  updatePasswordByEmailEndpoint: BASE_URL + '/api/update_password_by_email/',

  registerEndpoint: '/jwt/register',
  storageTokenKeyName: 'accessToken',
  onTokenExpiration: 'refreshToken', // logout | refreshToken
  createCampaign: BASE_URL + '/api/campaigns/',
  campaignDetails: BASE_URL + '/api/campaign-details/',
  addDonar: BASE_URL + '/api/donor/',
  superAdminDashboard: BASE_URL + '/api/super_admin_dashboard/',
  paymentDonate: BASE_URL + '/api/donate/',
  addPayment: BASE_URL + '/api/add_payment/',
  campaignDetailsUpdate: BASE_URL + '/api/campaign_details',
  organizationDetailsUpdate: BASE_URL + '/api/organization_details',
  CampaignSlugCheck: BASE_URL + '/api/campaign_details_by_slug',
  image_load_url: BASE_URL + '/media/',
  DonorID: BASE_URL + '/api/get_donor_id_by_email',
  CampaignTeamList: BASE_URL + '/api/campaign_teams/',
  DonorInstallmentInfo: BASE_URL + '/api/donor_installment_info/',
  EmailInfoCheck: BASE_URL + '/api/check_email/',
  LeadSourceCapture: BASE_URL + '/api/lead-source-capture/',
  LeadSourceList: BASE_URL + '/api/lead-source-capture/',
  Generateshareablelink: BASE_URL + '/api/generate_shareable_link/',
  LeadSourceListWithCampid: BASE_URL + '/api/get_lead_source/',
  CaptureLeadSource: BASE_URL + '/api/capture_lead_source/',
  GenerateshareableSinglelink:
    BASE_URL + '/api/generate_shareable_link_single/',
  AddAnonymous: BASE_URL + '/api/anonymous/',
  SaveCardInfo: BASE_URL + '/api/save_card_info/',
  DonorSaveCardList: BASE_URL + '/api/donor_save_card_list/',
  CampaignWiseDonor: BASE_URL + '/api/campaigns/',
  CampaignWiseDonationList: BASE_URL + '/api/donations_by_campaign/',
  CampaignTeamWiseDonor: BASE_URL + '/api/campaign_team_wise_donor/campaign/',
  CampaignTeamWiseDonations:
    BASE_URL + '/api/campaign_team_wise_donations/campaign/',
  TrackVisitor: BASE_URL + '/api/visitors/',
  AddDonorInfo: BASE_URL + '/api/donor/',
  DonationsInfo: BASE_URL + '/api/donations_details/',
  TransactionsInfo: BASE_URL + '/api/transactions_details/',
  BannerImage: BASE_URL + '/api/banner_image/',
  GETBannerImage: BASE_URL + '/api/banner_image?campaign_details_id=',
  BannerVideo: BASE_URL + '/api/banner_video/',
  GETBannerVideo: BASE_URL + '/api/banner_video?campaign_details_id=',

  CampaignWiseTeam: BASE_URL + '/api/campaign_wise_team/',

  GetCampaignIdByUserId: BASE_URL + '/api/get_campaign_by_user_id/',
  CampaignTeamDetails: BASE_URL + '/api/campaign_teams/',
  CampaignTeamDetailsBySlug: BASE_URL + '/api/team_details_by_slug/',
  CampaignSEODetails: BASE_URL + '/api/campaign-seo/',
  GetAllPublicCampaign: BASE_URL + '/api/priority-banner-image',
  CampaignEmails: BASE_URL + '/api/emails/',

  CampaignStats: BASE_URL + '/api/campaign-stats/',
  CampaignFiveTransactions: BASE_URL + '/api/last-five-transactions/',

  Products: BASE_URL + '/api/products/',
  GatewayAPI: BASE_URL + '/api/gateways/',
  ApplePayValidate: BASE_URL + '/api/apple_pay_validate/',
  StripeCheckoutSession: BASE_URL + '/api/create-checkout-session-stripe/',
  CampaignGetway: BASE_URL + '/api/gateways/campaign-gateways/?campaign_slug=',
  GetStripePaymentLink: BASE_URL + '/api/create_payment_link/',
  NextServerBase:
    BASE_URL === 'http://127.0.0.1:8000'
      ? 'http://localhost:3000'
      : 'https://givingamp.com',
  DeleteDonation: BASE_URL + '/api/delete-donation/',
  AddDonationList: BASE_URL + '/api/admin_donations_by_campaign/',
  GetUserProfile: BASE_URL + '/api/auth_me/',
  GetRecentActivity: BASE_URL + '/api/activity/recent',
  userCampaigns: BASE_URL + '/api/user-campaigns/',
};
